import { DEFAULT_LANG } from '../config/constants';

const sessionKey = 'session';
const languageKey = 'pollLanguage';
const refreshedKey = 'refreshed';
const pollHashKey = 'pollHash';

const setItem = (key: string, value: any): void => localStorage.setItem(key, JSON.stringify(value));

const getItem = (key: string): any => {
  const value = localStorage.getItem(key);
  return (value) ? JSON.parse(value) : null;
};

export const setSession = (session): void => {
  setItem(sessionKey, session);
};

export const getSession = (): any => {
  return getItem(sessionKey);
};

export const deleteSession = (): void => {
  setSession(null);
};


export const setRefreshed = (refreshedValue): void => {
  setItem(refreshedKey, refreshedValue);
};

export const getRefreshed = (): any => {
  return getItem(refreshedKey);
};

export const deleteRefreshed = (): void => {
  setRefreshed(false);
};

export const setPollHash = (hashValue): void => {
  setItem(pollHashKey, hashValue);
};

export const getPollHash = (): any => {
  return getItem(pollHashKey);
};

export const deletePollHash = (): void => {
  setPollHash(null);
};

export const setPollLanguage = (language): void => {
  setItem(languageKey, language);
};

export const getPollLanguage = (): any => {
  return getItem(languageKey) === null ? DEFAULT_LANG : getItem(languageKey);
};

export const deletePollLanguage = (): void => {
  setPollLanguage(null);
};
